export default {
      id: "grid-view-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#grid-view",
      toString: function () {
        return this.url;
      }
    }